/* iceberg-ui */
import { Box, Flex, IconWithVariant, Text } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { useTheme } from '@mui/material/styles';

/*  Images  */
import PictographPrimaryOneColorLightPurple from 'images/pictograph/SVG/pictograph-primary-oneColor-lightPurple.svg';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

const IncludedFeature = ({ feature }) => {
    const theme = useTheme();
    return (
        <Flex mb={3} alignItems="flex-start">
            <IconWithVariant
                variant="secondary"
                src="CheckCircle"
                size={48}
                wrapperProps={{
                    flexShrink: '0',
                    marginRight: '16px'
                }}
            />
            <Box>
                <Text
                    color={theme.palette.onboarding.titleTextColor}
                    fontSize={4}
                    dangerouslySetInnerHTML={{ __html: feature }}
                />
            </Box>
        </Flex>
    );
};

export const WhyInstallAgentGraphic = ({ MotionWrapper }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <>
            <Flex
                data-testid="onboardingWhyInstallAgentStepImg"
                justifyContent="center"
                maxHeight="65%"
                width="100%"
            >
                <MotionWrapper key="onboardingWhyInstallAgentStepMW">
                    <img
                        src={PictographPrimaryOneColorLightPurple}
                        alt={t('Pictograph.primaryLightPurple')}
                        width="240px"
                        data-testid="logoCloseUpImage"
                    />
                </MotionWrapper>
            </Flex>
            <Flex
                alignItems="center"
                data-testid="onboardingWhyInstallAgent"
                flexDirection="column"
                mt={4}
                mx="4%"
            >
                <Text
                    fontSize={['32px', '32px', '32px', 5]}
                    color={theme.palette.onboarding.titleTextColor}
                    fontWeight="600"
                    textAlign="center"
                    mt={5}
                    mb={4}
                >
                    {t('Onboarding.whyInstallAgent.title')}
                </Text>
                <Box>
                    {Array(3)
                        .fill()
                        .map((_, i) => (
                            <IncludedFeature
                                feature={t(
                                    `Onboarding.whyInstallAgent.reason.${i + 1}`
                                )}
                                // eslint-disable-next-line react/no-array-index-key
                                key={i}
                            />
                        ))}
                </Box>
            </Flex>
        </>
    );
};
